import React, { useState } from 'react';

import styled from 'styled-components';

import {
  Collapsible,
  CollapsibleGroup,
} from '~/techstyle-shared/react-components';

import SizeSelectionContent from './components/SizeSelectionContent';
import SizeSelectionHeader from './components/SizeSelectionHeader';
import { SizeTypes } from './constants';
import { useSizeSelectionContext } from './context';

const CollapsibleWrapper = styled.div`
  font-size: 16px;
  line-height: ${20 / 16};

  ${({ theme }) => theme.sizeSelectionExpansionPanel.collapsibleWrapper};
`;

function SizeSelectionExpansionPanel() {
  const { apparelOptions } = useSizeSelectionContext();

  const [sizeOpen, setSizeOpen] = useState(
    apparelOptions.values().next().value
  );

  return (
    <CollapsibleGroup allowMultipleOpen={false}>
      {Array.from(apparelOptions).map((sizeOption, index, list) => {
        const nextValue = list[index + 1] ?? null;
        const isOpen = sizeOpen === sizeOption;
        return (
          <>
            <CollapsibleWrapper
              showBra={apparelOptions.has(SizeTypes.BRA_SIZE)}
            >
              <Collapsible
                data-autotag={
                  isOpen
                    ? 'collapsible-size-grid-open'
                    : 'collapsible-size-grid-closed'
                }
                isOpen={isOpen}
                onOpen={() => setSizeOpen(sizeOption)}
                onClose={() => setSizeOpen(null)}
              >
                <div>
                  <SizeSelectionHeader
                    isOpen={sizeOpen}
                    sizeType={sizeOption}
                  />

                  <SizeSelectionContent
                    setSizeOpen={setSizeOpen}
                    sizeType={sizeOption}
                    openNext={setSizeOpen.bind(null, nextValue)}
                  />
                </div>
              </Collapsible>
            </CollapsibleWrapper>
          </>
        );
      })}
    </CollapsibleGroup>
  );
}

export default SizeSelectionExpansionPanel;
